// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-5ee18f03]{font-size:1.6rem!important;color:#fff;padding-left:1.5rem;font-weight:bolder}", ""]);
// Exports
module.exports = exports;
